




































































import { Component, Vue } from 'vue-property-decorator';
import { Log, SetInvoicePaidEditModel, UnpaidInvoiceViewModel } from '@/services/api/nswag/stapiclient_generated';
import { stAdminApi } from '@/services/st-api';
import StTabs from '@/components/tabs/StTabs.vue';
import AccountSettingsInvoice from '@/views/Settings/AccountSettingsInvoice.vue';
import { notifyError, notifySuccess } from '@/utlitities/notifications';
import StBadge from '@/components/basic/StBadge.vue';

@Component({
  components: { StBadge, StTabs, AccountSettingsInvoice },
})
export default class UnpaidInvoices extends Vue {
  invoices: UnpaidInvoiceViewModel[] = [];
  level = '';

  async mounted() {
    await this.loadData();
  }

  async loadData() {
    this.invoices = await stAdminApi.getUnpaidInvoices();
  }

  async setPaid(invoiceId: number, paidAt: string) {
    const model = SetInvoicePaidEditModel.fromJS({});
    model.invoiceId = invoiceId;
    model.date = paidAt;

    try {
      await stAdminApi.setInvoicePaid(model);
      notifySuccess('Als bezahlt markiert');
    } catch (e) {
      notifyError('Fehler');
    } finally {
      await this.loadData();
    }
  }

  async sendReminder(invoiceId: number) {
    try {
      await stAdminApi.sendInvoiceReminder(invoiceId);
      notifySuccess('Mahnung verschickt');
    } catch (e) {
      notifyError('Fehler');
    } finally {
      await this.loadData();
    }
  }

  async retryPayment(invoiceId: number) {
    try {
      await stAdminApi.retryCardPayment(invoiceId);
      notifySuccess('Versuch läuft');
    } catch (e) {
      notifyError('Fehler');
    } finally {
      await this.loadData();
    }
  }

  async writeOff(invoiceId: number) {
    try {
      await stAdminApi.writeOffInvoice(invoiceId);
      notifySuccess('Rechnung abgeschrieben');
    } catch (e) {
      notifyError('Fehler');
    } finally {
      await this.loadData();
    }
  }

  copy(string: string)
  {
    navigator.clipboard.writeText(string);
    notifySuccess('Kopiert');
  }
}
